import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './app.routes';
import {
  HttpClient,
  HttpClientModule,
  provideHttpClient,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { provideToastr } from 'ngx-toastr';
import { InterceptorsService } from './services/interceptor/interceptors.interceptor';
import { initializeApp, provideFirebaseApp,FirebaseAppModule } from '@angular/fire/app';
import { provideMessaging,getMessaging} from '@angular/fire/messaging';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '', '');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideToastr({
      preventDuplicates: true,
    }),
    provideClientHydration(),
    provideAnimationsAsync(),
    provideRouter(routes),
    provideHttpClient(),
    importProvidersFrom(HttpClientModule),
    importProvidersFrom(FirebaseAppModule),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
    importProvidersFrom([provideFirebaseApp(() => initializeApp({
      apiKey: "AIzaSyC_MZyIIX_VpnFQMYPRRY7DNQOVG3KJ3rk",
      authDomain: "dpworks-demo.firebaseapp.com",
      projectId: "dpworks-demo",
      storageBucket: "dpworks-demo.appspot.com",
      messagingSenderId: "239109084805",
      appId: "1:239109084805:web:e7c83b9eb3f9e8d7737bec",
      measurementId: "G-VK2VH5LRW8"
    })),
  provideMessaging(() => getMessaging()),]
),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorsService,
      multi: true,
    },
  ],
};
